import { useEffect, useState, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useParams } from "react-router-dom";
// import { fetchCaseById } from "../../store/user/userSlice";
import { useToast } from "../utilities/Toast";
import { updateLiveCaseToPendingLive } from "../../store/common/updateCaseStatusSlice";
import ConfirmModal from "../utilities/confirmModal";
import CaseDetails from "./caseDetails";
import Status from "./Status";

const Overview = () => {
  const dispatch = useAppDispatch();
  const { case_id } = useParams<{ case_id: string }>();
  const { showToast } = useToast();
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const { user } = useAppSelector((state) => state.auth);
  const { selectedCase, isLoading: caseLoading } = useAppSelector(
    (state) => state.adminCases
  );
  const [copiedField, setCopiedField] = useState<"case" | "owner" | null>(null);

  // Fetch case + notes together
  useEffect(() => {
    if (case_id) {
      // dispatch(fetchCaseById(case_id));
    }
  }, [case_id, dispatch]);

  const handleSubmit = () => {
    setShowConfirmModal(true);
  };

  async function handlePendingLive(case_id: string) {
    if (!case_id) {
      showToast("Invalid Case ID", "error");
      return;
    }

    const result = await dispatch(updateLiveCaseToPendingLive({ case_id }));

    if (updateLiveCaseToPendingLive.fulfilled.match(result)) {
      showToast("Case updated successfully", "success");
    } else if (updateLiveCaseToPendingLive.rejected.match(result)) {
      showToast(result.payload || "Case update failed", "error");
    }
  }

  const handleCopy = useCallback((text: string, field: "case" | "owner") => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 2000); // auto-reset after 2s
  }, []);

  return (
    <div className="w-full h-full p-3 min-h-[60vh]">
      <div className="">
        <Status />

        {/* Case Info */}
        <div className="space-y-3 w-full">
          <button
            onClick={() => handleSubmit()}
            disabled={["production", "admin read", "side admin"].includes(
              user?.role.toLowerCase() || ""
            )}
            className={`px-3 py-1  text-white rounded-md
                        ${["production", "admin read", "side admin"].includes(
              user?.role?.toLowerCase() || ""
            )
                ? "cursor-not-allowed bg-gray-400"
                : "bg-green-500 hover:bg-green-600"
              }
                        `}
          >
            Pending Live
          </button>
          <div className="bg-white border rounded-xl shadow-sm p-3 text-md space-y-1">
            {caseLoading ? (
              <p className="animate-pulse text-gray-400">Loading case…</p>
            ) : (
              <>
                <div className="flex items-center justify-between">
                  <CopyField
                    label="Case ID"
                    value={selectedCase?.case_id || "N/A"}
                    copied={copiedField === "case"}
                    onCopy={() =>
                      case_id && handleCopy(selectedCase?.case_id || "", "case")
                    }
                  />

                  <CopyField
                    label="Owner"
                    value={selectedCase?.case_owner || "N/A"}
                    copied={copiedField === "owner"}
                    onCopy={() =>
                      selectedCase?.case_owner &&
                      handleCopy(selectedCase.case_owner, "owner")
                    }
                  />

                  <p>
                    <strong>Created On:</strong>{" "}
                    {selectedCase?.creation_time_ms
                      ? new Date(selectedCase.creation_time_ms).toLocaleString()
                      : "N/A"}
                  </p>
                  <p>
                    <strong>Services:</strong>{" "}
                    {selectedCase?.service_type
                      ? selectedCase.service_type
                        .split(",")
                        .map((s) => s.trim())
                        .join(", ")
                      : "No services selected"}
                  </p>
                </div>
              </>
            )}
          </div>

          <CaseDetails />
        </div>
      </div>
      <ConfirmModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={() => {
          setShowConfirmModal(false);
          handlePendingLive(case_id || "");
        }}
        title={`Pending Live Case`}
        message={`Are you sure you want to make that case Pending Live?`}
        confirmColor="blue"
        confirmLabel="Yes, Confirm"
        cancelLabel="Cancel"
      />
    </div>
  );
};

// Subcomponent to isolate copy-flash rendering
const CopyField = ({
  label,
  value,
  copied,
  onCopy,
}: {
  label: string;
  value: string;
  copied: boolean;
  onCopy: () => void;
}) => (
  <p
    className={`cursor-pointer hover:underline ${copied ? "text-purple-500" : ""
      }`}
    onClick={onCopy}
  >
    <strong>{label}:</strong> {value}
  </p>
);

export default Overview;
